import script from "./BenefitsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitsSection.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitsSection.vue?vue&type=style&index=0&id=0b406c4c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b406c4c"]])

export default __exports__